export const controlButton = ({ icon, className = '' }) => {
    return `
    <div class="account-control-button ${className}">${icon}</div>
  `;
};
